"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("./index.vue"));
var _default = exports.default = {
  components: {
    UserSelectModel: _index.default
  },
  props: {
    value: {
      type: Object,
      default: undefined
    },
    selectModalProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    modelValue: {
      get() {
        if (!this.value) {
          this.$refs.userSelectModalRef?.reset();
        }
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    selectedValueText() {
      const {
        user,
        department
      } = this.modelValue ?? {};
      if (user) {
        return `${user.userName}-${user.deptName}`;
      }
      if (department) {
        return department.name;
      }
      return undefined;
    }
  },
  methods: {
    handleClick() {
      this.$refs.inputRef.blur();
      this.visible = true;
    },
    handleClear() {
      this.modelValue = undefined;
    },
    handleConfirm(value) {
      this.modelValue = value;
    }
  }
};